import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootUrl } from "../../redux/types";
import useResponsive from "../../hooks/useResponsive";
import useOnClickOutside from "../../hooks/useOnClickOutside";

const View = ({ handleLogout, sideMenuOpen }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOnClickOutside(dropdownRef, () => setOpen(false));
  const { isMobile } = useResponsive();
  const { role, name, logo, restaurantName, branchName } = useSelector(
    (state) => state.user,
  );

  const handleNavigate = (link) => navigate(link);

  const logoPath = RootUrl + "/" + logo;

  return (
    <div className="topbar">
      <nav
        className={`navbar-custom ${
          isMobile ? (sideMenuOpen ? "active" : "") : ""
        }`}
        style={{
          paddingLeft: "25px",
          paddingRight: "25px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {isMobile && (
          <li
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              marginRight: "15px",
            }}
          >
            <button
              className="btn btn-circle btn-outline-dark hamburger-menu-btn p-1 d-flex align-items-center justify-content-center"
              onClick={() => window.dispatchEvent(new Event("open-sidebar"))}
              title="Open Menu"
            >
              <i
                className="mdi mdi-menu"
                style={{ fontSize: "20px", lineHeight: 1 }}
              ></i>
            </button>
          </li>
        )}
        <ul
          className="list-unstyled topbar-nav mb-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => handleNavigate("/")}
          >
            <img
              src={role !== "superadmin" ? logoPath : "./images/logo.png"}
              style={{ height: "50px", width: "auto" }}
            />
          </li>
          <li className="hide-phone">
            <div
              className="nav-link waves-effect waves-light nav-user"
              style={{ paddingLeft: "5px" }}
            >
              <span
                className="font-weight-bold nav-user-name hidden-sm"
                style={{ fontSize: "16px", color: "#1e293b" }}
              >
                {branchName !== undefined ? branchName : restaurantName}
              </span>
            </div>
          </li>
        </ul>
        <ul className="list-unstyled topbar-nav float-right mb-0">
          <li className="position-relative px-0" ref={dropdownRef}>
            <div
              className="nav-link waves-effect waves-light nav-user px-0"
              onClick={() => setOpen(!open)}
              style={{
                cursor: "pointer",
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#475569",
                }}
              >
                <i
                  className="mdi mdi-account-outline"
                  style={{ fontSize: "22px" }}
                ></i>
              </div>
            </div>
            {open && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "100%",
                  marginTop: 0,
                  zIndex: 1000,
                  width: "240px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  boxShadow:
                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    padding: "12px 20px",
                    borderBottom: "1px solid #f1f5f9",
                  }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "15px",
                        color: "#0f172a",
                        lineHeight: "1.2",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {name || "User"}
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#64748b",
                        marginTop: "4px",
                        textTransform: "capitalize",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Role : {role}
                    </div>
                  </div>
                </div>

                <div style={{ padding: "8px" }}>
                  <div
                    onClick={() => handleLogout()}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      color: "#ef4444",
                      fontWeight: "500",
                      lineHeight: "1",
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#fef2f2")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <i
                      className="mdi mdi-logout"
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    ></i>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        transform: "translateY(1px)",
                      }}
                    >
                      Sign Out
                    </span>
                  </div>
                </div>
              </div>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default View;
